import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50" }, null, -1)
const _hoisted_3 = { class: "relative mx-auto z-10 overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all w-min:2/5 sm:p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-2xl font-roboto text-center mb-3" }, " Please select file ", -1)
const _hoisted_5 = { class: "flex content-center justify-between mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "text-dark-blue" }, "Choose Balances file for upload", -1)
const _hoisted_7 = { class: "flex justify-between mt-6" }

import {useReportStore} from "@/areas/reports/stores/reportStore";
import Toast from "@/helpers/Toast";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileInputModal',
  emits: ['upload', 'close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const reportStore = useReportStore();

const handleChange = (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    reportStore.setFile(file)
  }
};

const handleUpload = async () => {
  const result = await reportStore.uploadBalanceReport();
  
  if (result.isSuccessful){
    Toast.success("File upload successful")
  } else {
    Toast.error("File upload failed - try again later")
  }
  
  emit('close')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              type: "file",
              accept: "application/csv",
              onChange: handleChange,
              class: "border border-gray-300 rounded-lg py-2 pl-2 pr-2 outline-none shadow-sm w-auto mt-1.5"
            }, null, 32)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "flex items-center px-5 py-2 rounded-md shadow-md bg-transparent text-dark-blue border border-dark-blue"
        }, " Back "),
        _createElementVNode("button", {
          onClick: handleUpload,
          class: _normalizeClass([ !_unref(reportStore).file || _unref(reportStore).isLoading ? 'disabled bg-gray-500': 'bg-light-blue', "flex items-center px-5 py-2 rounded-md shadow-md text-white"])
        }, " Upload ", 2)
      ])
    ])
  ]))
}
}

})